<template>
  <div class="rbu-adjustment" style="display: contents">
    <tr v-if="value.adjustment_value_first">
      <td class="rbu-table-section-header">
        <div>Adjustment</div>
      </td>
      <td>Adjustment in value</td>
      <td>
        {{
          $parseNumber(
            value.adjustment_value,
            override_digit ? override_digit_number : 2
          )
        }}
      </td>
      <td></td>
      <td>
        <v-textarea
          outlined
          dense
          hide-details
          placeholder="Formula"
          clearable
          auto-grow
          rows="1"
          :value="value.adjustment_value_formula"
          @input="onAdjustmentValueFormulaUpdate"
        ></v-textarea>
      </td>
      <td>
        <v-textarea
          outlined
          auto-grow
          rows="1"
          dense
          hide-details
          placeholder="Description"
          :value="value.adjustment_value_descriptions"
          @input="$emit('update', { adjustment_value_descriptions: $event })"
        ></v-textarea>
      </td>
      <td>
        <v-btn
          icon
          color="primary"
          @click="
            $emit('update', {
              adjustment_value_first: !value.adjustment_value_first,
            })
          "
        >
          <v-icon>mdi-swap-vertical</v-icon>
        </v-btn>
      </td>
    </tr>
    <tr>
      <td class="rbu-section-fluctuation-column-1 rbu-table-section-header">
        <div v-if="!value.adjustment_value_first">Adjustment</div>
      </td>
      <td class="rbu-section-fluctuation-column-2">
        Adjustment in %
        <!-- {{
          value.adjustment_percentage
            ? `(${(parseFloat(value.adjustment_percentage) - 100).toFixed(2)}%)`
            : ""
        }} -->
      </td>
      <td class="rbu-section-fluctuation-column-value"></td>
      <td class="rbu-section-fluctuation-column-multiplier">
        {{ value.adjustment_percentage }}%
      </td>
      <td class="rbu-section-fluctuation-column-formula">
        <v-textarea
          outlined
          dense
          hide-details
          placeholder="100"
          auto-grow
          rows="1"
          clearable
          :value="value.adjustment_percentage_formula"
          @input="onAdjustmentPercentageFormulaUpdate"
        ></v-textarea>
      </td>
      <td class="rbu-section-fluctuation-column-descriptions">
        <v-textarea
          outlined
          auto-grow
          rows="1"
          dense
          hide-details
          placeholder="Description"
          :value="value.adjustment_percentage_descriptions"
          @input="
            $emit('update', { adjustment_percentage_descriptions: $event })
          "
        ></v-textarea>
      </td>
      <td>
        <v-btn
          icon
          color="primary"
          @click="
            $emit('update', {
              adjustment_value_first: !value.adjustment_value_first,
            })
          "
        >
          <v-icon>mdi-swap-vertical</v-icon>
        </v-btn>
      </td>
    </tr>
    <tr v-if="!value.adjustment_value_first">
      <td></td>
      <td>Adjustment in value</td>
      <td>
        {{
          $parseNumber(
            value.adjustment_value,
            override_digit ? override_digit_number : 2
          )
        }}
      </td>
      <td></td>
      <td>
        <v-textarea
          outlined
          dense
          hide-details
          placeholder="Formula"
          auto-grow
          rows="1"
          clearable
          :value="value.adjustment_value_formula"
          @input="onAdjustmentValueFormulaUpdate"
        ></v-textarea>
      </td>
      <td>
        <v-textarea
          outlined
          auto-grow
          rows="1"
          dense
          hide-details
          placeholder="Description"
          :value="value.adjustment_value_descriptions"
          @input="$emit('update', { adjustment_value_descriptions: $event })"
        ></v-textarea>
      </td>
      <td>
        <v-btn
          icon
          color="primary"
          @click="
            $emit('update', {
              adjustment_value_first: !value.adjustment_value_first,
            })
          "
        >
          <v-icon>mdi-swap-vertical</v-icon>
        </v-btn>
      </td>
    </tr>
  </div>
</template>
<script>
import floatingPointFix from "js-floating-point";

export default {
  name: "ContractRbuAdjustment",
  props: {
    value: Object,
    override_digit: Boolean,
    override_digit_number: Number,
  },
  setup(props, { root, emit }) {
    const onAdjustmentValueFormulaUpdate = function (evt) {
      console.debug("onAdjustmentValueFormulaUpdate", evt);

      let value;

      if (evt) {
        try {
          if (props.override_digit && props.override_digit_number) {
            value = floatingPointFix(eval(evt)).toFixed(
              props.override_digit_number
            );
          } else {
            value = floatingPointFix(eval(evt)).toFixed(2);
          }
        } catch (e) {
          value = 0;
          console.debug(e);
        }
      } else {
        value = 0;
      }

      emit("update", {
        adjustment_value: value,
        adjustment_value_formula: evt,
      });
    };

    const onAdjustmentPercentageFormulaUpdate = function (evt) {
      console.debug("onAdjustmentPercentageFormulaUpdate", evt);

      let value;

      if (evt) {
        try {
          if (props.override_digit && props.override_digit_number) {
            value = floatingPointFix(eval(evt)).toFixed(
              props.override_digit_number
            );
          } else {
            value = floatingPointFix(eval(evt)).toFixed(2);
          }
        } catch (e) {
          value = 0;
          console.debug(e);
        }
      } else {
        value = "100";
      }

      emit("update", {
        adjustment_percentage: value,
        adjustment_percentage_formula: evt,
      });
    };

    return {
      onAdjustmentValueFormulaUpdate,
      onAdjustmentPercentageFormulaUpdate,
    };
  },
};
</script>

<style lang="less">
.rbu-adjustment {
  td {
    padding: 8px;
  }
}
</style>
